// import { createBrowserHistory } from 'history/createBrowserHistory';
// export default createBrowserHistory();

// import { browserHistory } from "react-router";
// export default browserHistory;
import {createBrowserHistory} from "history";
export default createBrowserHistory();